import { Action, createReducer, on } from '@ngrx/store';
import { InAppNotificationsState } from 'src/app/in-app-notifications/store/in-app-notifications.state';
import * as InAppNotificationsActions from 'src/app/in-app-notifications/store/actions/in-app-notifications.actions';

export const initialState: InAppNotificationsState = {
    loading: false,
    inAppNotifications: [],
    error: undefined,
    inAppNotificationSentAlert: null,
    filter: null,
    unreadInAppNotificationCounts: {
        unreadNotificationCount: 0,
        overdueTasksAssignedToMeCount: 0
    },
    unreadInAppNotificationCountsForDelegation: {
        unreadNotificationCount: 0,
        overdueTasksAssignedToMeCount: 0
    },
    unreadInAppNotificationsTabCounters: [],
    hasOverdueTasksCreatedByMe: false,
    user: null
};

const reducer = createReducer(
    initialState,

    on(InAppNotificationsActions.getInAppNotifications, (state, action) => ({
        ...state,
        loading: true,
        filter: action.filter
    })),

    on(InAppNotificationsActions.getInAppNotificationsSuccess, (state, action) => ({
        ...state,
        loading: false,
        inAppNotifications: action.inAppNotifications
    })),

    on(InAppNotificationsActions.getInAppNotificationsFailure, (state, action) => ({
        ...state,
        inAppNotifications: [],
        loading: false,
        error: JSON.stringify(action.error)
    })),

    on(InAppNotificationsActions.getUnreadInAppNotificationsCountSuccess, (state, action) => ({
        ...state,
        loading: false,
        unreadInAppNotificationCounts: action.unreadInAppNotificationCounts
    })),

    on(InAppNotificationsActions.getUnreadInAppNotificationsCountFailure, (state, action) => ({
        ...state,
        inAppNotifications: [],
        loading: false,
        error: JSON.stringify(action.error)
    })),

    on(InAppNotificationsActions.getUnreadInAppNotificationsCountForDelegationSuccess, (state, action) => ({
        ...state,
        loading: false,
        unreadInAppNotificationCountsForDelegation: action.unreadInAppNotificationCounts
    })),

    on(InAppNotificationsActions.getUnreadInAppNotificationsCountForDelegationFailure, (state, action) => ({
        ...state,
        inAppNotifications: [],
        loading: false,
        error: JSON.stringify(action.error)
    })),

    on(InAppNotificationsActions.getUnreadInAppNotificationsTabCountersSuccess, (state, action) => ({
        ...state,
        loading: false,
        unreadInAppNotificationsTabCounters: action.unreadInAppNotificationsTabCounters
    })),

    on(InAppNotificationsActions.getUnreadInAppNotificationsTabCountersFailure, (state, action) => ({
        ...state,
        loading: false,
        error: JSON.stringify(action.error)
    })),

    on(InAppNotificationsActions.hasOverdueTasksCreatedByMeSuccess, (state, action) => ({
        ...state,
        loading: false,
        hasOverdueTasksCreatedByMe: action.hasOverdueTasksCreatedByMe
    })),

    on(InAppNotificationsActions.hasOverdueTasksCreatedByMeFailure, (state, action) => ({
        ...state,
        loading: false,
        error: JSON.stringify(action.error)
    })),

    on(InAppNotificationsActions.clearInAppNotificationData, (state, action) => ({
        ...initialState
    })),

    on(InAppNotificationsActions.getInAppNotificationByIdSuccess, (state, action) => {
        const notifications = [...state.inAppNotifications];
        notifications.unshift(action.inAppNotification);
        return {
            ...state,
            loading: false,
            inAppNotifications: notifications
        };
    }),

    on(InAppNotificationsActions.getInAppNotificationByIdFailure, (state, action) => ({
        ...state,
        loading: false,
        error: JSON.stringify(action.error)
    })),

    on(InAppNotificationsActions.updateInAppNotificationSettings, (state) => ({
        ...state,
        loading: true
    })),

    on(InAppNotificationsActions.updateInAppNotificationSettingsSuccess, (state) => ({
        ...state,
        loading: false
    })),

    on(InAppNotificationsActions.updateInAppNotificationSettingsFailure, (state, action) => ({
        ...state,
        loading: false,
        error: JSON.stringify(action.error)
    })),

    on(InAppNotificationsActions.markAllAsRead, (state) => ({
        ...state,
        loading: true
    })),

    on(InAppNotificationsActions.markAllAsReadSuccess, (state) => ({
        ...state,
        loading: false
    })),

    on(InAppNotificationsActions.markAllAsReadFailure, (state, action) => ({
        ...state,
        loading: false,
        error: JSON.stringify(action.error)
    })),

    on(InAppNotificationsActions.getInAppNotificationsUserSuccess, (state, action) => ({
        ...state,
        user: action.user
    })),

    on(InAppNotificationsActions.getInAppNotificationsUserFailure, (state, action) => ({
        ...state,
        user: null,
        error: JSON.stringify(action.error)
    })),

    on(InAppNotificationsActions.inAppNotificationSentAlertSuccess, (state, action) => ({
        ...state,
        loading: false,
        inAppNotificationSentAlert: action.data
    })),

    on(InAppNotificationsActions.inAppNotificationSentAlertFailure, (state, action) => ({
        ...state,
        inAppNotificationSentAlert: null,
        loading: false,
        error: JSON.stringify(action.error)
    })),

    on(InAppNotificationsActions.resetState, (state) => ({
        ...initialState,
        user: state.user,
        unreadInAppNotificationCounts: state.unreadInAppNotificationCounts,
        unreadInAppNotificationsTabCounters: state.unreadInAppNotificationsTabCounters,
        hasOverdueTasksCreatedByMe: state.hasOverdueTasksCreatedByMe
    }))
);

export function inAppNotificationsReducer(state: InAppNotificationsState | undefined, action: Action) {
    return reducer(state, action);
}
